/**
 * @generated SignedSource<<c51c1be1ee2759ed506f3fda1f5171fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type GoalScoringMode = "OKR" | "SIMPLE";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
import type { FragmentRefs } from "relay-runtime";
export type storeWorkspace$data = {
  readonly workspace: {
    readonly activationId: string | null;
    readonly cloudId: string;
    readonly goalScoringMode: GoalScoringMode;
    readonly id: string;
    readonly keyPrefix: string;
    readonly name: string;
    readonly organisationId: string;
    readonly timezone: string;
    readonly type: WorkspaceType;
    readonly userHasInvitePermission: boolean | null;
    readonly userIsOrgAdmin: boolean;
    readonly uuid: string;
  } | null;
  readonly workspaceCount: number | null;
  readonly " $fragmentType": "storeWorkspace";
};
export type storeWorkspace$key = {
  readonly " $data"?: storeWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"storeWorkspace">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "storeWorkspace"
};

(node as any).hash = "f18816925571b48b886c041f35ccdbd6";

export default node;
